import React from "react";
import { euro } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { CreditCard, QrCode } from "lucide-react";

const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
const KIND = { mensile: "Mensile", una_tantum: "Una tantum" };
export const EXTRA_PAY = {
  plafond: ["Dal tuo Plafond", "lo scaliamo ora con l'attivazione: il cliente te lo paga in negozio"],
  sim: ["Dal credito della SIM", "si attiva da solo quando la SIM ha abbastanza credito"],
};

const Choice = ({ on, onClick, title, hint, Icon, testid }) => (
  <button type="button" onClick={onClick} className={`rounded-lg border px-3 py-2 text-left text-sm transition-colors ${on ? "border-primary bg-primary/10" : "border-border hover:border-primary/60"}`} data-testid={testid}>
    <span className="flex items-center gap-1.5 font-medium">{Icon && <Icon className="w-4 h-4 text-primary" />}{title}</span>
    <span className="block text-xs text-muted-foreground">{hint}</span>
  </button>
);

export const SimTypePick = ({ value, onChange, testid = "im-sim-type" }) => (
  <div className="space-y-1.5" data-testid={testid}>
    <Label>Tipo di SIM</Label>
    <div className="grid grid-cols-2 gap-2 max-w-lg">
      <Choice on={value !== "esim"} onClick={() => onChange("sim")} title="SIM fisica" hint="una SIM del tuo magazzino" Icon={CreditCard} testid={`${testid}-sim`} />
      <Choice on={value === "esim"} onClick={() => onChange("esim")} title="eSIM" hint="Uno Mobile invia il QR all'email del cliente" Icon={QrCode} testid={`${testid}-esim`} />
    </div>
  </div>
);

export const ActivationExtras = ({ catalog = [], modes = ["plafond", "sim"], value = [], payment, onChange }) => {
  if (!catalog.length) return null;
  const toggle = (n) => onChange({ extras: value.includes(n) ? value.filter((x) => x !== n) : [...value, n] });
  return (
    <div className="rounded-lg border border-border p-4 space-y-3" data-testid="im-extras">
      <div><p className="text-sm font-medium">Extra oltre all'offerta base (facoltativi)</p><p className="text-xs text-muted-foreground">Si attivano sulla nuova SIM appena Uno Mobile approva l'attivazione. Mensili: si rinnovano ogni mese con il credito della SIM. Una tantum: valgono una volta sola.</p></div>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-2">
        {catalog.map((x) => (
          <label key={x.name} className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-sm cursor-pointer transition-colors ${value.includes(x.name) ? "border-primary bg-primary/5" : "border-border hover:border-primary/50"}`} data-testid={`im-extra-${slug(x.name)}`}>
            <Checkbox checked={value.includes(x.name)} onCheckedChange={() => toggle(x.name)} data-testid={`im-extra-${slug(x.name)}-check`} />
            <span className="min-w-0 flex-1 truncate">{x.name}</span>
            <Badge variant="outline" className="text-[10px] shrink-0">{KIND[x.kind] || x.kind}</Badge>
            <span className="font-medium shrink-0">{euro(x.cost)}</span>
          </label>
        ))}
      </div>
      {value.length > 0 && <div className="space-y-1.5" data-testid="im-extras-payment">
        <Label>Chi paga gli extra</Label>
        <div className="grid sm:grid-cols-2 gap-2">{modes.map((m) => <Choice key={m} on={payment === m} onClick={() => onChange({ extras_payment: m })} title={EXTRA_PAY[m][0]} hint={EXTRA_PAY[m][1]} testid={`im-extras-pay-${m}`} />)}</div>
      </div>}
    </div>
  );
};
